module.exports = __webpack_public_path__ + "img/2.55e8dcb3.jpg";